import React from 'react'
import { useEffect } from 'react'
import { seeBlockedFriendList, unblockFriend } from '../../actions/friendsActions'
import { connect } from 'react-redux';
import { resetInfo } from '../../actions/userActions';
import inMemoryJWT from '../../auth/inMemoryJwt';

const BlockedFriendList = ({ history, seeBlockedFriendList, blockedFriendList, unblockFriend, isLoading }) => {


    useEffect(() => {
        if(!(inMemoryJWT.getToken())){
            inMemoryJWT.getRefreshedToken()
        }

        inMemoryJWT.waitForTokenRefresh().then(() => {
            seeBlockedFriendList()
        })
        
    },[])

    return (
        <div className="">
            <div className="block-list-tittle-container">
                <div className="wrapper-2 mt-5 mb-5">
                    <div className="friends-count-friend-list">
                        Bloqueados
                            <div className="littleText ml-1 mb-1">{!isLoading && Object.values(blockedFriendList).length}</div>
                    </div>
                    <div className="search-friend-list"></div>
                </div>
                <div className="text-block-friend-list">Cuando bloqueas a alguine, esa persona ya no puede ver lo que publicas en tu
                    biografia,etiquetarte,invitarte a eventos o grupos, inicias una conversacion contigo, ni agregarte a su lista de amigos, Esto no incluye las apps, los juegos o los grupos en que ambos participan</div>
            </div>
            <div className="block-list-container">
                {!isLoading && Object.values(blockedFriendList).length > 0 ? Object.values(blockedFriendList).map(([id,{user,social}]) => {
                    return <div key={user._id} className="content-social-show-list">
                        <div className="circle-small-purple"></div>
                        <div className="content-name-show-list-social">
                            <div onClick={() => {
                                resetInfo()
                                history.push('/Profile/' + user._id)
                            }} className="pointer text-bold">@{user.name}</div>
                        </div>
                        <div className="pointer" onClick={() => { unblockFriend(user._id) }}>Desbloquear</div>
                    </div>
                }) :
                    'No tienes bloqueados'}
            </div>
        </div>
    )

}
const mapStateToProps = (state) => {
    return {
        blockedFriendList: state.userInfo.blockedFriendList,
        isLoading: state.userInfo.isLoadingBlockedFriendList
    }
}
export default connect(mapStateToProps, { seeBlockedFriendList, unblockFriend })(BlockedFriendList)
